import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { reduce } from "et3-type-guards";
import { borderWidths, fontWeights, sizes } from "et3-ui-library";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCorePersonalStore from "../../stores/core/core-personal-store";

const KhattabatWelcome = withLiteObserverAndTheme(() => {
  const fullName = reduce(() => getCorePersonalStore().user.get().fullName, "");
  const userImageName = getCorePersonalStore().userPofilePic.get();

  return (
    <Stack spacing={1} alignItems="center" sx={{ textAlign: "center" }}>
      <Avatar
        src={require(`../../assets/images/${userImageName}.png`)}
        alt={fullName}
        sx={{
          width: sizes.avatar.lg,
          height: sizes.avatar.lg,
          mb: 1,
          border: `${borderWidths.thin}px solid`,
          borderColor: "primary.main"
        }}
      />
      <Typography variant="h5" color="text.secondary">
        {i18n.get("WELCOME")}
      </Typography>
      <Typography
        variant="h4"
        fontWeight={fontWeights.bold}
        color="primary.main"
        sx={{ wordBreak: "break-word" }}
      >
        {fullName}
      </Typography>
    </Stack>
  );
});
export default KhattabatWelcome;
